import {
  addRefillIntervals,
  type RefillInterval,
  type TreatmentPrescriptionContext,
  type TreatmentWithRelations,
} from '@snootsvet/shared'

/** Suggests an expiry equal to (refills + 1) * interval, e.g. 6 months for a 3-monthly interval prescription with 1 refill. */
export function calculateDefaultPrescriptionExpiry(
  prescribedAt: Date,
  refills: number,
  interval: RefillInterval
): Date {
  return addRefillIntervals(prescribedAt, interval, refills + 1)
}

export type Prescription = TreatmentWithRelations & TreatmentPrescriptionContext
export type PrescriptionGroup = {
  latest: Prescription
  previous: Prescription[]
}

export function groupPrescriptions(treatments: Prescription[]): PrescriptionGroup[] {
  const groups = new Map<string, PrescriptionGroup>()
  const sorted = [...treatments].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )
  for (const treatment of sorted) {
    if (treatment.treatmentType !== 'prescription') continue
    const key = treatment.isExternal
      ? `external:${treatment.catalogProductId ?? treatment.id}`
      : `internal:${treatment.productId ?? treatment.id}`
    const group = groups.get(key)
    if (group) group.previous.push(treatment)
    else groups.set(key, { latest: treatment, previous: [] })
  }
  return [...groups.values()]
}
